import { Box, Button, Link as CLink, Image, Link, Skeleton } from '@chakra-ui/react';
import * as React from 'react';
import { Link as RLink } from 'react-router-dom';
import { routes } from '../../../../../../constants/routes';
import { commonConfig } from '../../../../config';
import { MenuItem, RenderProps } from '../../../Menu/Menu';

export const defaultItems: MenuItem[] = [
  {
    to: routes.HOME_EXPLICIT,
    trans: 'global.home',
    render: null,
    order: 0,
    px: 2,
  },
  {
    to: routes.ABOUT,
    trans: 'global.about',
    order: 10,
    px: 2,
  },
  {
    as: CLink,
    trans: 'global.help',
    href: commonConfig.links.knowledgebase.default,
    target: '_blank',
    rel: 'noopener noreferrer',
    order: 11,
    px: 2,
  },
];

export const Loader = (): React.ReactElement => <Skeleton w="150px" h="24px" order={20} />;
export const HostButton = ({ text, order }: RenderProps): React.ReactElement => (
  <Box order={order}>
    <Button
      id="get-started"
      data-id="get-started"
      as={RLink}
      to={routes.HOST}
      className="none"
      colorScheme="gray.900"
      variant="outline"
      size="sm"
      px="5"
    >
      {text}
    </Button>
  </Box>
);
export const DashButton = ({ text, order }: RenderProps): React.ReactElement => (
  <Box order={order}>
    <Button
      as={RLink}
      to={routes.DASHBOARD.SESSIONS.link}
      className="none"
      colorScheme="gray.900"
      variant="outline"
      size="sm"
      px="5"
    >
      {text}
    </Button>
  </Box>
);
export const UnstyledButton = (props: RenderProps): React.ReactElement => (
  <Button variant="unstyled" size="sm" fontSize="inherit" {...props} />
);
export const SignUpButton = ({ text, onClick, order }: RenderProps): React.ReactElement => (
  <Box order={order}>
    <Button
      colorScheme="red"
      size="sm"
      color="white"
      fontSize="inherit"
      onClick={onClick}
      order={order}
    >
      {text}
    </Button>
  </Box>
);

export const ProductHuntButton = (props: RenderProps): React.ReactElement => (
  <Box ml={2} order={props.order}>
    <Link
      href="https://www.producthunt.com/posts/waitroom?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-waitroom"
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
      <Image
        src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=384028&theme=dark&period=daily"
        alt="Rumi - Reshape&#0032;Chaos&#0032;into&#0032;Collaboration&#0032;with&#0032;AI&#0045;Driven&#0032;Meetings&#0032;⚡ | Product Hunt"
        w={{ base: 160, xl: 140, '2xl': 200 }}
        h="auto"
        htmlWidth="250"
        htmlHeight="54"
      />
    </Link>
  </Box>
);
